export default {
  namespaced: true,
  proxy_rtsp_server: {
    title: "servidor proxy rtsp | servidores proxy rtsp",
    name: "nombre",
    api_host: "ruta api",
    rtsp_host: "ruta RTSP",
    playback_host: "ruta playback",
    hls_host: "ruta HLS",
    webrtc_host: "ruta webrtc",
    log_level: "Nivel de registro",
    log_destinations: "Destinos de registro",
    log_file: "Archivo de registro",
    sys_log_prefix: "Prefijo Syslog",
    read_timeout: "Tiempo de espera de lectura",
    write_timeout: "Tiempo de espera de escritura",
    write_queue_size: "Tamaño de cola de escritura",
    udp_max_payload_size: "Tamaño máximo de carga UDP",
    run_on_connect: "Ejecutar al conectar",
    run_on_connect_restart: "Reiniciar al ejecutar en conexión",
    run_on_disconnect: "Ejecutar al desconectar",
    auth_method: "Método de autenticación",
    auth_internal_users: "Usuarios internos",
    auth_http: "Autenticación HTTP",
    auth_http_address: "Dirección de autenticación HTTP",
    auth_http_exclude: "Excluir de autenticación HTTP",
    auth_jwt_jwks: "JWT JWKS",
    auth_jwt_jwks_fingerprint: "Huella digital JWT JWKS",
    auth_jwt_claim_key: "Clave de reclamación JWT",
    auth_jwt_exclude: "Excluir de JWT",
    auth_jwt_in_http_query: "JWT en consulta HTTP",
    enable_api: "Habilitar API",
    api_address: "Dirección de API",
    enable_api_encryption: "Habilitar cifrado de API",
    api_server_key: "Clave de servidor API",
    api_server_cert: "Certificado de servidor API",
    api_allow_origin: "Permitir origen API",
    api_trusted_proxies: "Proxies confiables de API",
    enable_metrics: "Habilitar métricas",
    metrics_address: "Dirección de métricas",
    enable_metrics_encryption: "Habilitar cifrado de métricas",
    metrics_server_key: "Clave de servidor de métricas",
    metrics_server_cert: "Certificado de servidor de métricas",
    metrics_allow_origin: "Permitir origen de métricas",
    metrics_trusted_proxies: "Proxies confiables de métricas",
    enable_pprof: "Habilitar Pprof",
    pprof_address: "Dirección de Pprof",
    enable_pprof_encryption: "Habilitar cifrado de Pprof",
    pprof_server_key: "Clave de servidor Pprof",
    pprof_server_cert: "Certificado de servidor Pprof",
    pprof_allow_origin: "Permitir origen Pprof",
    pprof_trusted_proxies: "Proxies confiables de Pprof",
    enable_playback: "Habilitar reproducción",
    playback_address: "Dirección de reproducción",
    enable_playback_encryption: "Habilitar cifrado de reproducción",
    playback_server_key: "Clave de servidor de reproducción",
    playback_server_cert: "Certificado de servidor de reproducción",
    playback_allow_origin: "Permitir origen de reproducción",
    playback_trusted_proxies: "Proxies confiables de reproducción",
    enable_rtsp: "Habilitar RTSP",
    rtsp_transports: "Transportes RTSP",
    rtsp_encryption: "Cifrado RTSP",
    rtsp_address: "Dirección RTSP",
    rtsps_address: "Dirección RTSPS",
    rtp_address: "Dirección RTP",
    rtcp_address: "Dirección RTCP",
    multicast_ip_range: "Rango IP de multidifusión",
    multicast_rtp_port: "Puerto RTP de multidifusión",
    multicast_rtcp_port: "Puerto RTCP de multidifusión",
    rtsp_server_key: "Clave de servidor RTSP",
    rtsp_server_cert: "Certificado de servidor RTSP",
    rtsp_auth_methods: "Métodos de autenticación RTSP",
    enable_rtmp: "Habilitar RTMP",
    rtmp_address: "Dirección RTMP",
    rtmp_encryption: "Cifrado RTMP",
    rtmps_address: "Dirección RTMPS",
    rtmp_server_key: "Clave de servidor RTMP",
    rtmp_server_cert: "Certificado de servidor RTMP",
    enable_hls: "Habilitar HLS",
    hls_address: "Dirección HLS",
    enable_hls_encryption: "Habilitar cifrado HLS",
    hls_server_key: "Clave de servidor HLS",
    hls_server_cert: "Certificado de servidor HLS",
    hls_allow_origin: "Permitir origen HLS",
    hls_trusted_proxies: "Proxies confiables de HLS",
    hls_always_remux: "Siempre remultiplexar HLS",
    hls_variant: "Variante HLS",
    hls_segment_count: "Número de segmentos HLS",
    hls_segment_duration: "Duración de segmento HLS",
    hls_part_duration: "Duración de parte HLS",
    hls_segment_max_size: "Tamaño máximo de segmento HLS",
    hls_directory: "Directorio HLS",
    hls_muxer_close_after: "Cerrar multiplexor HLS después",
    enable_webrtc: "Habilitar WebRTC",
    webrtc_address: "Dirección WebRTC",
    enable_webrtc_encryption: "Habilitar cifrado WebRTC",
    webrtc_server_key: "Clave de servidor WebRTC",
    webrtc_server_cert: "Certificado de servidor WebRTC",
    webrtc_allow_origin: "Permitir origen WebRTC",
    webrtc_trusted_proxies: "Proxies confiables de WebRTC",
    webrtc_local_udp_address: "Dirección UDP local WebRTC",
    webrtc_local_tcp_address: "Dirección TCP local WebRTC",
    webrtc_ips_from_interfaces: "IPs de interfaces WebRTC",
    webrtc_ips_from_interfaces_list: "Lista de IPs de interfaces WebRTC",
    webrtc_additional_hosts: "Hosts adicionales WebRTC",
    webrtc_ice_servers_2: "Servidores ICE WebRTC 2",
    webrtc_handshake_timeout: "Tiempo de espera de negociación WebRTC",
    webrtc_track_gather_timeout: "Tiempo de espera de recopilación de pistas WebRTC",
    webrtc_stun_gather_timeout: "Tiempo de espera de recopilación STUN WebRTC",
    enable_srt: "Habilitar SRT",
    srt_address: "Dirección SRT",
    api_settings: "Configuración de API",
    authentication: "Autenticación",
    password_not_required_for_user_any: "Contraseña no requerida para usuario 'any'"
  },
};
